/** React-query keys for stops (dnm-work#165). */
export const stopsQueryKey = (shipmentId: number) =>
  ['admin', 'shipments', 'stops', shipmentId] as const;

/** Keys every stop change refreshes: the Stopped trucks list, the dashboard badge and the shipment lists/detail. */
export const STOP_INVALIDATE_KEYS = [
  ['admin', 'stopped'],
  ['admin', 'dashboard'],
  ['admin', 'shipments'],
];
